import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { AuditService } from "@app/services/http/audit.service";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";

import "moment-timezone";
import { BaseAuditRenderer } from "@app/view/shared/audits/base/base-audit-renderer";
import { GridComponent as GridComponent_1 } from "../../base-pages/base-data-table-page/grid.component";

@Component({
  selector: "app-ticket-audit-renderer",
  templateUrl: "./ticket-audit-renderer.component.html",
  styleUrls: ["./ticket-audit-renderer.component.css"],
  imports: [GridComponent_1]
})
export class TicketAuditRendererComponent
  extends BaseAuditRenderer
  implements OnInit
{
  auditService: AuditService;

  @Input() ticketId: string;
  @Input() snapshotId: string;
  displayedValues = [
    "ticketStatus",
    "ticketCompletionCode",
    "despatchedTime",
    "arrivedTime",
    "startedTime",
    "completedTime",
    "duration",
    "resourceAvailability",
    "skillProfile",
    "visit",
    "comments",
    "followOnRequired",
    "followOnActioned",
    "lockToResource"
  ];
  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "ticket");

    this.auditService = auditService;
  }

  ngOnInit() {
    this.getAudit(
      this.snapshotId,
      this.ticketId,
      this.auditGrid,
      this.displayedValues
    );
  }
}
